import { useRef, useState } from "react";
import ColumnFilterPopover from "../table/ColumnFilterPopover";

/**
 * Barra de filtros ativos. Todos os chips vêm do mesmo estado da tabela;
 * clicar no texto abre o filtro daquela coluna (mesmo com a coluna oculta).
 * items: [{ id, label, column?, onRemove }]
 */
const ActiveFilterChip = ({ item }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const filterKind = item.column?.columnDef?.meta?.config?.filter;
    const canEdit = Boolean(filterKind) && filterKind !== "ids";
    return (
        <span className="flex items-center gap-1 rounded-full border border-primary/50 bg-mgs-elevated px-2 py-0.5 text-xs text-laranjinha/80">
            {canEdit ? (
                <button ref={anchorRef} type="button" className="hover:text-white" title="Editar filtro" aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
                    {item.label}
                </button>
            ) : (
                <span>{item.label}</span>
            )}
            <button type="button" aria-label={`Remover filtro ${item.label}`} className="px-1 hover:text-white" onClick={item.onRemove}>×</button>
            {open ? <ColumnFilterPopover column={item.column} anchorRef={anchorRef} onClose={() => setOpen(false)} /> : null}
        </span>
    );
};

const ActiveFiltersBar = ({ items = [], onClearAll }) => {
    if (!items.length) return null;
    return (
        <div className="flex flex-wrap items-center gap-1" role="group" aria-label="Filtros ativos">
            {items.map((item) => <ActiveFilterChip key={item.id} item={item} />)}
            <button type="button" className="text-xs text-laranjinha/60 underline hover:text-primary" onClick={onClearAll}>Limpar tudo</button>
        </div>
    );
};

export default ActiveFiltersBar;
